:host {
  --actionButtonsHeight: 56px;
}

#easmFindingPanel {
  display: flex;
  height: 100%;
  flex-direction: column;

  #sections {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    padding: 0 calc(2 * var(--spacer)) 0 calc(2 * var(--spacer));
  }

  #panelTitle {
    background-color: var(--white-layout-303-level-2-elevation);
    padding: calc(var(--spacer) * 7) calc(var(--spacer) * 2) var(--spacer) calc(var(--spacer) * 2);
  }

  gz-generic-details-sections {
    position: relative;
    height: auto;
    padding-bottom: var(--spacer);
    &:not(.affected-devices) {
      &:after {
        content: '';
        width: 100%;
        height: 1px;
        background-color: var(--chart-101-pressed-dividers);
        position: absolute;
        bottom: 0;
      }
    }
  }
}
